import styled from '@emotion/styled';
import { Box, Divider, Grid, Typography } from '@mui/material';
import Header from 'components/Common/Header';
import DetailItem from 'components/Staff/ItemDetail';
import Button from 'components/Common/Button';
import AssistanceFooter from 'components/Common/AssistanceFooter';
import ProfileContainer from 'components/Account/ProfileContainer';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getAddress } from 'utils/helpers';

const Container = styled('div')({
    backgroundColor: '#F2F2F6',
    padding: '20px', // Add consistent padding to the main container
    minHeight: '100vh', // Ensure a minimum height to cover the viewport
});

const InnerContainer = styled('div')({
    backgroundColor: 'white',
    marginBottom: 52,
});

function MyAccount() {
    const navigate = useNavigate();
    const { user, isMerchant, merchant } = useSelector((state: RootState) => ({
        user: state.user,
        isMerchant: state.auth.isMerchant,
        merchant: state.user.defaultMerchant,
    }));
    const { userInfo, userResponse, address } = user || {};
    const { name, email, username, imgUrl, telephone, status } = userInfo || {};
    const { catholicDirectoryAccountNumber, parishName } = userResponse || {};
    const { city = '', state = '', zipCode = '' } = address || {};

    return (
        <Container>
            <Header />
            <div style={{ backgroundColor: 'white', alignItems: 'center', marginTop: 42 }}>
                <Typography sx={{ p: 2, marginLeft: 2 }} variant="h6">
                    Account Details
                </Typography>
                <Divider />
            </div>

            <InnerContainer>
                <Box sx={{ padding: '1rem' }}>
                    {' '}
                    {/* Add consistent padding */}
                    <Box sx={{ ml: 10, mr: 10 }}>
                        <Box>
                            <ProfileContainer
                                isEmployee={!isMerchant}
                                showEditIcon
                                catholicDirectoryAccountNumber={catholicDirectoryAccountNumber}
                                status={status}
                                name={name}
                                email={username}
                                imageUrl={imgUrl}
                            />
                            <Divider />
                        </Box>
                        <Grid sx={{ my: 3 }} container spacing={2} justifyContent={'space-between'}>
                            {/* Left Container */}
                            <Grid item xs={12} md={6}>
                                <DetailItem label="Name" value={name || ''} />
                                <DetailItem label="Email/user name" value={email || ''} />
                                <DetailItem label="Parish Name" value={parishName || merchant?.name || ''} />
                                <DetailItem label="Phone" value={telephone ? String(telephone) : ''} />
                                <DetailItem label="Role" value={isMerchant ? 'Merchant' : 'Clerk'} />
                            </Grid>
                            {/* Right Container */}
                            <Grid item xs={12} md={6}>
                                {' '}
                                {/* Adjust the column size for a 12-column grid */}
                                <DetailItem label="Address" value={getAddress(address)} />
                                <DetailItem label="City" value={city} />
                                <DetailItem label="State" value={state} />
                                <DetailItem label="Zip" value={zipCode} />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                marginTop: 74,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                            }}
                        >
                            <Button
                                onClick={() => navigate(routes.account.changePassword, { state: { type: 'resetPassword' } })}
                                sx={{ width: { xs: '90%', sm: '40%' } }}
                                title="Reset Password"
                            />
                            <div style={{ width: '100%' }}>
                                <AssistanceFooter />
                            </div>
                        </div>
                    </Box>
                </Box>
            </InnerContainer>
        </Container>
    );
}

export default MyAccount;
